/**
 * Validates a value is alpha
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name alpha
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  const res = /^[a-zA-Z]+$/.test(value);
  return Promise.resolve(res ? null : 'not-alpha');
}

module.exports = validate;